import { createSlice } from "@reduxjs/toolkit";

import { NEW_DOCUMENT_ID } from "../constants";

const INITIAL_STATE = {
  isDirty: false,
  id: null,
  entityType: null,
  versionId: null,
  title: "",
  content: "",
  status: "",
  createdAt: null,
  createdBy: "",
  lastUpdatedAt: [],
  lastUpdatedBy: "",
  linkedOutlineItems: [],
  isLockedBy: null,
  isLockedByAnotherUser: false,
  isSyncing: false,
  syncTasks: [],
};

export const currentDocumentSlice = createSlice({
  name: "currentDocument",
  initialState: INITIAL_STATE,
  reducers: {
    setIsDirty(state, { payload: isDirty = false }) {
      state.isDirty = isDirty;
    },
    setDocumentData(state, { payload = {} }) {
      const keys = Object.keys(payload);

      keys.forEach((key) => {
        state[key] = payload[key];
      });
    },

    updateSyncTask(state, { payload }) {
      if (!payload) {
        return;
      }
      const { hash, status, id, name } = payload;
      if (!hash) {
        return;
      }
      const index = state.syncTasks.findIndex((t) => t.hash === hash);
      if (index > -1) {
        state.syncTasks[index] = { ...state.syncTasks[index], status, id };
      } else {
        state.syncTasks.push({
          hash,
          status: status || "QUEUED",
          id,
          name: name || state.title,
        });
      }
    },
    setDataForNewDocument: (_, { payload: { entityType, title } }) => {
      return {
        ...INITIAL_STATE,
        id: NEW_DOCUMENT_ID,
        entityType,
        title,
      };
    },
    clearDocumentData: () => INITIAL_STATE,
  },
});

export const {
  setIsDirty,
  setDocumentData,
  updateSyncTask,
  setDataForNewDocument,
  clearDocumentData,
} = currentDocumentSlice.actions;

export default currentDocumentSlice.reducer;
